export default __webpack_public_path__ + "static/media/phone.4b4e8309.svg";